import BlockHeader from '@components/BlockHeader';
import { BlockContainer } from '@components/Blocks';
import { CardProps } from '@components/Card';
import CardGrid from '@components/CardGrid';
import CtaButton from '@components/CtaButton';
import { CommonLink } from '@lib/features/commonLinks';
import { Entry, isEntry } from '@lib/features/entries';
import { useView } from '@lib/store';
import { useTranslations } from 'next-intl';

export type EventCardsProps = {
  Component: (props: CardProps<Entry<'event'>>) => React.ReactElement | null;
  heading?: string | null;
  content?: string | null;
  items?: Entry<'event'>[];
  indexLink?: CommonLink;
};

const EventCards = ({ Component, heading, content, items = [], indexLink }: EventCardsProps) => {
  const view = useView();
  const t = useTranslations('event');

  const indexHref = indexLink?.uri || undefined;
  const ticketIndexHref = indexLink?.uri === '/tickets';

  const showIndexLink = !isEntry(view, 'eventIndex') || !isEntry(view, 'ticketIndex');

  return (
    <BlockContainer>
      <BlockHeader
        {...{
          variant: 'split',
          heading,
          HeadingProps: { variant: 'h1' },
          content,
          cta: showIndexLink && indexHref && (
            <CtaButton variant="text" href={indexHref}>
              {ticketIndexHref ? t('ticketIndexLink') : t('indexLink')}
            </CtaButton>
          ),
        }}
      />
      <CardGrid Component={Component} sm={6} md={4} lg={3} items={items} />
    </BlockContainer>
  );
};

export default EventCards;
